export default "../../src/img/email.webp";